import { Button } from "@/template/components";
import * as S from "./styles";

const NotAvailableModal = ({ isOpen, onClose, number }) => {
  if (!isOpen) return null;

  return (
    <S.Overlay>
      {/* stopPropagation prevents closing the modal when clicking inside the card */}
      <S.ModalCard onClick={(e) => e.stopPropagation()}>
        <S.ContentWrapper>
          <S.Title>This number is unavailable</S.Title>
          <S.Description>
            It looks like <b>{number}</b> was a popular number! Unfortunately
            this number is no longer available, but don't worry, just choose an
            alternative from our range and checkout in minutes
          </S.Description>
        </S.ContentWrapper>
        <S.ButtonContainer>
          <Button
            variant={"solid"}
            size="lg"
            onClick={onClose}
          >
            Pick a new number
          </Button>
        </S.ButtonContainer>
      </S.ModalCard>
    </S.Overlay>
  );
};

export default NotAvailableModal;
